import { renderSlot as _renderSlot, vModelText as _vModelText, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "lang", "autocomplete", "name", "placeholder", "readonly", "disabled", "spellcheck", "maxlength"]
const _hoisted_2 = ["id", "lang", "name", "autocomplete", "placeholder", "disabled", "spellcheck", "readonly", "maxlength"]
const _hoisted_3 = ["id", "lang", "readonly", "name", "spellcheck", "maxlength"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _normalizeProps(_guardReactiveProps({..._ctx.$attrs, ..._ctx.$props})), _createSlots({
    label: _withCtx(() => [
      _renderSlot(_ctx.$slots, "label")
    ]),
    default: _withCtx(() => [
      (!$props.readOnly && $props.type === 'text')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            id: _ctx.fieldId,
            key: `${_ctx.fieldId}-editable-text`,
            ref: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model) = $event)),
            class: _normalizeClass($options.classes),
            type: "text",
            lang: $options.langCode,
            autocomplete: $props.autoComplete,
            name: _ctx.name,
            placeholder: _ctx.placeholder,
            readonly: $props.readOnly,
            disabled: _ctx.disabled,
            spellcheck: $options.spellcheckAttr,
            maxlength: $props.maxlength,
            onInput: _cache[1] || (_cache[1] = (...args) => ($options.onInput && $options.onInput(...args))),
            onKeyup: _cache[2] || (_cache[2] = (...args) => ($options.onKeyUp && $options.onKeyUp(...args))),
            onBlur: _cache[3] || (_cache[3] = (...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
            onFocus: _cache[4] || (_cache[4] = (...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
            onKeydown: _cache[5] || (_cache[5] = (...args) => (_ctx.onKeydown && _ctx.onKeydown(...args))),
            "data-qa": "text-field-input"
          }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1)), [
            [_vModelText, _ctx.model]
          ])
        : _createCommentVNode("v-if", true),
      (!$props.readOnly && $props.type === 'password')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            id: _ctx.fieldId,
            key: `${_ctx.fieldId}-editable-password`,
            ref: "input",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.model) = $event)),
            class: _normalizeClass($options.classes),
            type: "password",
            lang: $options.langCode,
            name: _ctx.name,
            autocomplete: $props.autoComplete,
            placeholder: _ctx.placeholder,
            disabled: _ctx.disabled,
            spellcheck: $options.spellcheckAttr,
            readonly: $props.readOnly,
            maxlength: $props.maxlength,
            onKeyup: _cache[7] || (_cache[7] = (...args) => ($options.onKeyUp && $options.onKeyUp(...args))),
            onBlur: _cache[8] || (_cache[8] = (...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
            onFocus: _cache[9] || (_cache[9] = (...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
            onKeydown: _cache[10] || (_cache[10] = (...args) => (_ctx.onKeydown && _ctx.onKeydown(...args))),
            "data-qa": "text-field-input"
          }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2)), [
            [_vModelText, _ctx.model]
          ])
        : _createCommentVNode("v-if", true),
      ($options.isReadOnlyWithValue)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            id: _ctx.fieldId,
            key: `${_ctx.fieldId}-readonly-input`,
            ref: "input",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.model) = $event)),
            class: _normalizeClass($options.classes),
            type: "text",
            lang: $options.langCode,
            readonly: $props.readOnly,
            name: _ctx.name,
            spellcheck: $options.spellcheckAttr,
            maxlength: $props.maxlength,
            "data-qa": "text-field-input"
          }, null, 10 /* CLASS, PROPS */, _hoisted_3)), [
            [_vModelText, _ctx.model]
          ])
        : ($props.readOnly)
          ? (_openBlock(), _createElementBlock("span", {
              key: `${_ctx.fieldId}-readonly-span`,
              class: _normalizeClass(['gfu-field__input gfu-field__input--faux-expanded gfu-field__input--readonly',
                       { 'gfu-field__input--small': _ctx.small },
                       { 'gfu-field__input--conceal': $props.conceal }]),
              readonly: "readonly",
              "data-qa": "text-field-input"
            }, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString($props.readOnlyPlaceholder), 1 /* TEXT */)
              ])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
      (!$props.readOnly || $options.isReadOnlyWithValue)
        ? _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 4)
        : _createCommentVNode("v-if", true)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots.description)
      ? {
          name: "field-description",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "description")
          ]),
          key: "0"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
}